import { DeleteOutlined, SaveOutlined, DownloadOutlined, EditOutlined, ReloadOutlined, SyncOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { ContentHeader } from "../../components";
import { duyetLuongQuyetToanNLD, importFileLuongBoSung, layChiTietLuongQuyetToan, luuDieuChinhLuongBoSungNLD, luuLuongBoSungNLD, taiDieuChinhLuongBoSungNLD, taiDuLieuLuongBoSungNLDTheoNam, taiDuLieuLuongBoSungNguoiLD, trinhLuongBoSungNQL, trinhLuongQuyetToanNLD, xoaLuongBoSungNQL, xoaLuongQuyetToanNLD, xuatDuLieuLuongBoSung, xuatExcelLuongBoSungNLD } from "../../services/luong";
import { toast } from "react-toastify";
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, Tag } from "antd";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { currencyFormat, dateCommon, formatVND, validateMessages } from '../../helpers/common';
import Dropzone from 'react-dropzone';
import { ChiTietLuongBoSungResponse, ImportFileLuongBoSungRequest, LuongBoSungNLDResponse } from '../../models/luong/LuongBoSung';
import Column from 'antd/es/table/Column';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import dayjs from 'dayjs';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import { useNavigate } from 'react-router-dom';
import { Links } from '../../helpers/Links';

var optionsLuongBoSung = [{
    value: 0,
    label: "Theo năm"
},
{
    value: 1,
    label: "Theo quý"
}]

var optionsLoaiMuc = [{
    value: 0,
    label: "Tổng cộng"
},
{
    value: 1,
    label: "Chi tiết"
}]

const LuongBoSungNLD = () => {
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState(false);

    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalTrinh, setShowModalTrinh] = useState<boolean>(false);
    const [showModalDuyet, setShowModalDuyet] = useState<boolean>(false);

    const [showModalDieuChinh, setShowModalDieuChinh] = useState<boolean>(false);
    const [isDieuChinh, setIsDieuChinh] = useState<boolean>(false);
    const [saveButton, setSaveButton] = useState<boolean>(false);
    const [isTinhLai, setIsTinhLai] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [dataLuongBoSung, setDataLuongBoSung] = useState<Array<LuongBoSungNLDResponse>>([]);
    const [file, setFile] = useState<any>();
    const dispatch = useDispatch();
    const [idNhomNhanSu, setIdNhomNhanSu] = useState<number | null>(null);
    const [idLuongQuyetToan, setIdLuongQuyetToan] = useState<number>(0);
    const [chiTietLBS, setChiTietLBS] = useState<ChiTietLuongBoSungResponse>(new ChiTietLuongBoSungResponse);
    const [loaiQuyetToan, setLoaiQuyetToan] = useState<number>(0);
    const [loaiMuc, setLoaiMuc] = useState<number>(0);
    const [quy, setQuy] = useState<number>(-1);
    const [nam, setNam] = useState<number>(-1);
    const [thangNhanLuong, setThangNhanLuong] = useState<Date | null>(null);
    const [formDieuChinh] = Form.useForm();
    const [trangThai, setTrangThai] = useState(-1);
    const navigate = useNavigate();

    const handleChangeCurrency = (fieldName: string, formattedFieldName: string) => (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            [fieldName]: parsedValue,
            [formattedFieldName]: format
        });
    };

    const handleChangeCurrencyDieuChinh = (fieldName: string, formattedFieldName: string) => (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        formDieuChinh.setFieldsValue({
            [fieldName]: parsedValue,
            [formattedFieldName]: format
        });
    };    

    const xuatBaoCao = async (data: any) => {
        setLoading(true);
        try {
            var response = await xuatDuLieuLuongBoSung(data?.idNhomNhanSu, data?.tongLuongQuyetToan, data?.quyQuyetToan, data?.namQuyetToan);
            let link = document.createElement('a');

            link.download = `MauLuongBoSung.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            toast.success('Tải xuống file mẫu thành công!')
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    const handleUpload = async () => {
        setShowModal(false);
        if (file) {
            form.validateFields().then(async (values) => {
                const formData = new FormData();
                formData.append('file', file);
                var request: ImportFileLuongBoSungRequest = {
                    file: file,
                    idNhomNhanSu: values?.idNhomNhanSu,
                    namQuyetToan: values?.namQuyetToan
                }
                try {
                    var response = await importFileLuongBoSung(request);
                    //setDataLuongBoSung(response);
                    toast.success("Import dữ liệu lương bổ sung thành công");
                    setSaveButton(true);
                    setFile(null);
                } catch (error) {
                    setShowModal(false);
                    setFile(null);
                    toast.error("Không thể import file. Vui lòng thử lại sau");
                }
            });
        } else {
            toast.error('Vui lòng chọn một tệp tin để tải lên.');
        }
    };

    const handleFileChange = (files: any) => {
        form.validateFields().then((values) => {
            try {
                if (files.length > 0) {
                    const selectedFile = files[0];
                    if (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        setFile(selectedFile);
                    } else {
                        alert("Vui lòng chọn một file Excel (định dạng .xlsx).");
                    }
                }
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
            }
            setShowModal(true);
        }).catch((e) => {
            setShowModal(false);
        });

    };

    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatExcelLuongBoSungNLD(idLuongQuyetToan);
            let link = document.createElement('a');
            link.download = `Luong_TT_NLĐ.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }

    const eventSaveLuongBoSung = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                if (dataLuongBoSung.length <= 0) {
                    toast.error("Không có dữ liệu tính lương bổ sung");
                }
                else {
                    const namQuyetToan = loaiQuyetToan === 0 ? values?.thoiGianQuyetToanNam?.$y :
                        values?.thoiGianQuyetToanQuy?.$y;
                    const quyQuyetToan = loaiQuyetToan === 0 ? 0 : values?.thoiGianQuyetToanQuy?.$M / 3 + 1;

                    if (!isDieuChinh) {
                        var request = {
                            id: idLuongQuyetToan,
                            idNhomNhanSu: 3,
                            quy: loaiQuyetToan == 0 ? 5 : quyQuyetToan,
                            nam: namQuyetToan,
                            loai: loaiMuc,
                            loaiBoSung: loaiQuyetToan,
                            thangNhan: thangNhanLuong,
                            ten: values?.tenQuyLuong,
                            tongLuongQuyetToan: 0,
                            tongLuongThangDau: 0,
                            tongLuongThangGiua: 0,
                            tongLuongThangCuoi: 0,
                            dsLuongBoSungs: dataLuongBoSung,
                            isThangTamTinh: values?.isThangTamTinh,
                            isTinhLai: idLuongQuyetToan == 0 ? false : isTinhLai
                        }
                        if (loaiMuc == 0) {
                            request.tongLuongQuyetToan = values?.tongLuongQuyetToan
                        }
                        else {
                            request.tongLuongThangDau = parseInt(values?.tongLuongThangDau),
                                request.tongLuongThangGiua = parseInt(values?.tongLuongThangGiua),
                                request.tongLuongThangCuoi = parseInt(values?.tongLuongThangCuoi)
                        };

                        const data = await luuLuongBoSungNLD(request);

                        toast.success("Lưu lương bổ sung thành công");
                        navigate(Links.Luong.BoSung);
                    }
                    else {
                        var requestDieuChinh = {
                            idLuongQuyetToan: idLuongQuyetToan,
                            quy: chiTietLBS?.quy,
                            nam: chiTietLBS?.nam,
                            loai: loaiMuc,
                            thangNhan: thangNhanLuong,
                            ten: values?.tenQuyLuong,
                            tongLuongThangDau: values?.tongLuongThangDau,
                            tongLuongThangGiua: values?.tongLuongThangGiua,
                            tongLuongThangCuoi: values?.tongLuongThangCuoi,
                            dsLuongBoSungs: dataLuongBoSung,
                            isThangTamTinh: 0
                        }
                        const data = await luuDieuChinhLuongBoSungNLD(requestDieuChinh);

                        toast.success("Lưu điều chỉnh lương bổ sung thành công");
                        navigate(Links.Luong.BoSung);
                    }
                }
            } catch (error: any) {
                toast.error(error.message || "Có lỗi xảy ra, lưu không thành công");
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    };

    const eventTrinh = async () => {
        try {
            setShowModalTrinh(false);
            dispatch(showLoadingScreen());
            await trinhLuongQuyetToanNLD(idLuongQuyetToan);
            navigate(Links.Luong.BoSung);
            toast.success("Trình lương bổ sung NLĐ thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventDuyet = async () => {
        try {
            setShowModalDuyet(false);
            dispatch(showLoadingScreen());
            await duyetLuongQuyetToanNLD(idLuongQuyetToan);
            navigate(Links.Luong.BoSung);
            toast.success("Duyệt lương bổ sung NLĐ thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    };

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaLuongQuyetToanNLD(idLuongQuyetToan);
            navigate(Links.Luong.BoSung);
            toast.success("Xóa lương bổ sung NLĐ thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const taiDuLieu = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            const namQuyetToan = loaiQuyetToan === 0 ? form.getFieldsValue(['thoiGianQuyetToanNam'])?.thoiGianQuyetToanNam?.$y : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$y;
            const quyQuyetToan = loaiQuyetToan === 0 ? 0 : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$M / 3 + 1;
            setQuy(quyQuyetToan);
            setNam(namQuyetToan);
            try {
                if (values?.loaiQuyetToan == 1) {
                    var request = {
                        idNhomNhanSu: 3,
                        quyQuyetToan: quyQuyetToan,
                        namQuyetToan: namQuyetToan,
                        tongLuongDuocNhan: 0,
                        tongLuongThangDau: 0,
                        tongLuongThangGiua: 0,
                        tongLuongThangCuoi: 0,
                        isThangTamTinh: values?.isThangTamTinh
                    }
                    if (loaiMuc == 0) {
                        request.tongLuongDuocNhan = values?.tongLuongQuyetToan
                    }
                    else {
                        request.tongLuongThangDau = values?.tongLuongThangDau
                        request.tongLuongThangGiua = values?.tongLuongThangGiua
                        request.tongLuongThangCuoi = values?.tongLuongThangCuoi
                    };

                    var data = await taiDuLieuLuongBoSungNguoiLD(request);
                    setDataLuongBoSung(data);
                }
                else if (values?.loaiQuyetToan == 0) {
                    var requestNam = {
                        namQuyetToan: namQuyetToan,
                        tongLuongDuocNhan: values?.tongLuongQuyetToan
                    };

                    var dataNam = await taiDuLieuLuongBoSungNLDTheoNam(requestNam);
                    setDataLuongBoSung(dataNam);
                }

                toast.success("Tải dữ liệu tính lương bổ sung thành công");
                setSaveButton(true);
                setIsTinhLai(true);
                setFile(null);
            } catch (error: any) {
                setDataLuongBoSung([]);
                toast.error(error.message || "Không thể tải dữ liệu. Vui lòng thử lại sau");
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            const namQuyetToan = loaiQuyetToan === 0 ? form.getFieldsValue(['thoiGianQuyetToanNam'])?.thoiGianQuyetToanNam?.$y : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$y;
            const quyQuyetToan = loaiQuyetToan === 0 ? 0 : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$M / 3 + 1;
            const data = {
                idNhomNhanSu: values?.idNhomNhanSu,
                namQuyetToan: namQuyetToan,
                quyQuyetToan: quyQuyetToan,
                tongLuongQuyetToan: parseInt(values?.tongLuongQuyetToan)
            };
            xuatBaoCao(data);
        }
        catch (err: any) {
        }
        setLoading(false);
    };

    const onFinishDieuChinh = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            setLoading(true);
            var request = {
                idNhomNhanSu: idNhomNhanSu,
                idLuongQuyetToan: idLuongQuyetToan,
                tongLuongThangDau: values?.tongLuongThangDau,
                tongLuongThangGiua: values?.tongLuongThangGiua,
                tongLuongThangCuoi: values?.tongLuongThangCuoi,
            }
            setLoaiMuc(1);
            form.setFieldsValue({
                loaiMuc: 1,
                tongLuongThangDau: values?.tongLuongThangDau,
                tongLuongThangDauStr: values?.tongLuongThangDau ? currencyFormat.formatMoney(values?.tongLuongThangDau) : "",
                tongLuongThangGiua: values?.tongLuongThangGiua,
                tongLuongThangGiuaStr: values?.tongLuongThangGiua ? currencyFormat.formatMoney(values?.tongLuongThangGiua) : "",
                tongLuongThangCuoi: values?.tongLuongThangCuoi,
                tongLuongThangCuoiStr: values?.tongLuongThangCuoi ? currencyFormat.formatMoney(values?.tongLuongThangCuoi) : "",
            })
            var rs = await taiDieuChinhLuongBoSungNLD(request);
            setDataLuongBoSung(rs);
            setSaveButton(true);
            toast.success("Tải dữ liệu điều chỉnh thành công");
        }
        catch (err: any) {
            toast.error(err.message || "Tải dữ liệu điều chỉnh lương bổ sung thất bại!");
        }
        setShowModalDieuChinh(false);
        dispatch(hideLoadingScreen());
        setLoading(false);
    };

    const layChiTiet = async (id: number) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var data = await layChiTietLuongQuyetToan(id);
            setDataLuongBoSung(data?.dsLuongBoSung);
            setLoaiQuyetToan(data?.loaiBoSung == 1 ? 0 : data?.loaiBoSung == 2 ? 1 : 3);
            setLoaiMuc(data?.loai);
            setChiTietLBS(data);
            setQuy(data?.quy);
            setNam(data?.nam);
            setTrangThai(data?.trangThai)
            form.setFieldsValue({
                tenQuyLuong: data?.ten || '',
                loaiQuyetToan: data?.loaiBoSung == 1 ? 0 : data?.loaiBoSung == 2 ? 1 : 3,
                loaiMuc: data?.loai,
                thoiGianQuyetToanQuy: dayjs(dateCommon.formatDate(new Date(data?.nam, (data?.quy != null && data?.quy < 5) ? data?.quy * 3 - 3 : 6, 1)), "DD/MM/YYYY"),
                thoiGianQuyetToanNam: dayjs(dateCommon.formatDate(new Date(data?.nam, (data?.quy != null && data?.quy < 5) ? data?.quy * 3 - 1 : 6, 1)), "YYYY"),
                thangNhan: data?.thangQuyetToan != null ? dayjs(dateCommon.formatDate(data?.thangQuyetToan), "DD/MM/YYYY") : undefined,
                isThangTamTinh: data?.isThangTamTinh
            })
            if (data?.loai == 0) {
                form.setFieldsValue({
                    tongLuongQuyetToan: data?.tongLuongDuocNhan,
                    tongLuongQuyetToanStr: data?.tongLuongDuocNhan ? currencyFormat.formatMoney(data?.tongLuongDuocNhan) : "",
                })
            }
            else {
                form.setFieldsValue({
                    tongLuongThangDau: data?.tongLuongThangDau,
                    tongLuongThangDauStr: data?.tongLuongThangDau ? currencyFormat.formatMoney(data?.tongLuongThangDau) : "",
                    tongLuongThangGiua: data?.tongLuongThangGiua,
                    tongLuongThangGiuaStr: data?.tongLuongThangGiua ? currencyFormat.formatMoney(data?.tongLuongThangGiua) : "",
                    tongLuongThangCuoi: data?.tongLuongThangCuoi,
                    tongLuongThangCuoiStr: data?.tongLuongThangCuoi ? currencyFormat.formatMoney(data?.tongLuongThangCuoi) : "",
                })
            }
        } catch (error: any) {
            toast.error(error);
        }
        dispatch(hideLoadingScreen());
        setIsLoading(false);
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        if (id > 0) {
            setIdLuongQuyetToan(id);
            layChiTiet(id);
        } else {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            form.setFieldsValue({ thangNhan: dayjs(dateCommon.formatDate(new Date()), "DD/MM/YYYY") })
            setThangNhanLuong(firstDay);            
        }
    }, [])

    return <section>
        {showModalDelete && <ModalTextForm show
            title="Xoá quyết toán lương"
            handleClose={() => setShowModalDelete(false)}
            handleSave={eventDelete}>
            Xác nhận xóa lương bổ sung người lao động
        </ModalTextForm>}
        {showModalTrinh && <ModalTextForm show
            title="Trình quyết toán lương"
            handleClose={() => setShowModalTrinh(false)}
            handleSave={eventTrinh}>
            Xác nhận trình lương bổ sung người lao động
        </ModalTextForm>}
        {showModalDuyet && <ModalTextForm show
            title="Duyệt quyết toán lương"
            handleClose={() => setShowModalDuyet(false)}
            handleSave={eventDuyet}>
            Xác nhận duyệt lương bổ sung người lao động
        </ModalTextForm>}
        <ModalTextForm
            show={showModal}
            title="Chọn file lương bổ sung"
            handleClose={() => setShowModal(false)}
            handleSave={handleUpload}
        >
            <Dropzone onDrop={handleFileChange} multiple={false}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div {...getRootProps()}
                        className="hrm-dropzone-uploadfile"
                    >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <p>Kéo và thả tệp tin ở đây...</p>
                        ) : file ? (
                            <div>
                                <p>File đã chọn: {file?.name}</p>
                                <p>Kích thước: {file?.size} bytes</p>
                            </div>
                        ) : (
                            <p>Kéo và thả hoặc chọn một file Excel ở đây.</p>
                        )}
                    </div>
                )}
            </Dropzone>
        </ModalTextForm>
        {showModalDieuChinh && <ModalTextForm title="Điều chỉnh lương bổ sung"
            hideFooter
            show={showModalDieuChinh}
            handleClose={() => setShowModalDieuChinh(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinishDieuChinh}
                form={formDieuChinh}
            >
                <Row gutter={16}>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label={"Tổng lương quyết toán tháng" + " " + (chiTietLBS?.quy * 3 - 2)}
                            name="tongLuongThangDauStr"
                            rules={[
                                {
                                    required: true
                                },
                                {
                                    max: 20
                                }
                            ]}
                        >
                            <Input
                                prefix="₫ "
                                onChange={handleChangeCurrencyDieuChinh('tongLuongThangDau', 'tongLuongThangDauStr')}
                                placeholder="Tổng lương quyết toán tháng"
                            />
                        </Form.Item>
                        <Form.Item hidden name="tongLuongThangDau" >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label={"Tổng lương quyết toán tháng" + " " + (chiTietLBS?.quy * 3 - 1)}
                            name="tongLuongThangGiuaStr"
                            rules={[
                                {
                                    required: true
                                },
                                {
                                    max: 20
                                }
                            ]}
                        >
                            <Input
                                prefix="₫ "
                                onChange={handleChangeCurrencyDieuChinh('tongLuongThangGiua', 'tongLuongThangGiuaStr')}
                                placeholder="Tổng lương quyết toán tháng"
                            />
                        </Form.Item>
                        <Form.Item hidden name="tongLuongThangGiua" >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label={"Tổng lương quyết toán tháng" + " " + (chiTietLBS?.quy * 3)}
                            name="tongLuongThangCuoiStr"
                            rules={[
                                {
                                    required: true
                                },
                                {
                                    max: 20
                                }
                            ]}
                        >
                            <Input
                                placeholder="Tổng lương quyết toán tháng"
                                prefix="₫ "
                                onChange={handleChangeCurrencyDieuChinh('tongLuongThangCuoi', 'tongLuongThangCuoiStr')}
                            />
                        </Form.Item>
                        <Form.Item hidden name="tongLuongThangCuoi" >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" className="float-right" htmlType="submit">
                        Tải dữ liệu điều chỉnh lương bổ sung
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <ContentHeader title="Lương bổ sung Người lao động" />
        <Tabs
            tabBarExtraContent={
                <Space>
                    {
                        idLuongQuyetToan > 0 &&
                        <Button
                            loading={isLoading}
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined rev="" />}
                            onClick={handleExport}
                        >Xuất excel
                        </Button>
                    }
                    {
                        idLuongQuyetToan > 0 && trangThai == 0 &&
                        <Button
                            type="primary" danger
                            icon=<DeleteOutlined rev="" />
                            onClick={() => { setShowModalDelete(true) }}
                        >
                            Xóa
                        </Button>
                    }
                    {
                        idLuongQuyetToan > 0 && trangThai == 0 &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalTrinh(true) }}
                        >
                            Trình phê duyệt
                        </Button>
                    }
                    {
                        trangThai == 2 &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalDuyet(true) }}
                        >
                            Duyệt
                        </Button>
                    }
                    {
                        (trangThai <= 0 || trangThai == undefined) &&
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={eventSaveLuongBoSung}
                        >
                            Lưu
                        </Button>
                    }

                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Quyết toán lương",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    onFinish={onFinish}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="6" >
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Tên quỹ lương" name="tenQuyLuong">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Loại quyết toán" name="loaiQuyetToan">
                                                <Select notFoundContent="Không có dữ liệu"
                                                    onChange={(e) => {
                                                        setLoaiQuyetToan(e);

                                                    }}
                                                    value={loaiQuyetToan}
                                                    options={optionsLuongBoSung}
                                                    loading={isLoading}
                                                    placeholder="Loại quyết toán"
                                                    disabled={idLuongQuyetToan > 0 ? true : false} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={loaiQuyetToan === 1 ? "4" : "6"}>
                                            <Form.Item rules={[
                                                {
                                                    required: loaiQuyetToan === 0 ? true : false
                                                },
                                            ]} label="Kỳ quyết toán" name="thoiGianQuyetToanNam" hidden={loaiQuyetToan === 1}>
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={idLuongQuyetToan > 0 ? true : false}
                                                    style={{ width: "100%" }}
                                                    format="YYYY"
                                                    placeholder="Chọn thời gian"
                                                    picker="year" />
                                            </Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: loaiQuyetToan === 1 ? true : false
                                                },
                                            ]} label="Kỳ quyết toán" name="thoiGianQuyetToanQuy" hidden={loaiQuyetToan === 0}>
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={idLuongQuyetToan > 0 ? true : false}
                                                    style={{ width: "100%" }}
                                                    format="[Quý] Q/YYYY"
                                                    placeholder="Chọn thời gian"
                                                    picker="quarter" />
                                            </Form.Item>
                                        </Col>
                                        {
                                            loaiQuyetToan === 1 && <Col span="5">
                                                <Form.Item valuePropName="checked" name="isThangTamTinh" label="Tạm tính tháng cuối trong quý">
                                                    <Checkbox disabled={idLuongQuyetToan > 0} />
                                                </Form.Item>
                                            </Col>
                                        }                                        
                                        <Col span={loaiQuyetToan === 1 ? "3" : "6"}>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Loại mức tính" name="loaiMuc">
                                                <Select notFoundContent="Không có dữ liệu"
                                                    onChange={(e) => {
                                                        setLoaiMuc(e);

                                                    }}
                                                    disabled={idLuongQuyetToan > 0 ? true : false}
                                                    value={loaiMuc}
                                                    options={optionsLoaiMuc}
                                                    loading={isLoading}
                                                    placeholder="Loại mức" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        {loaiMuc == 0 && <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Quỹ lương quyết toán" name="tongLuongQuyetToanStr">
                                                <Input prefix="₫ "
                                                    disabled={trangThai > 0 ? true : false}
                                                    onChange={handleChangeCurrency('tongLuongQuyetToan', 'tongLuongQuyetToanStr')}
                                                />
                                            </Form.Item>
                                            <Form.Item hidden name="tongLuongQuyetToan" >
                                                <Input disabled={idLuongQuyetToan > 0 ? true : false} />
                                            </Form.Item>
                                        </Col>}
                                        {loaiMuc == 1 && <>
                                            <Col span="6">
                                                <Form.Item rules={[
                                                    {
                                                        required: true
                                                    },
                                                ]} label="Quỹ lương tháng đầu trong quý" name="tongLuongThangDauStr">
                                                    <Input prefix="₫ "
                                                        disabled={idLuongQuyetToan > 0 ? true : false}
                                                        onChange={handleChangeCurrency('tongLuongThangDau', 'tongLuongThangDauStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="tongLuongThangDau" >
                                                    <Input disabled={idLuongQuyetToan > 0 ? true : false} />
                                                </Form.Item>
                                            </Col>
                                            <Col span="6">
                                                <Form.Item rules={[
                                                    {
                                                        required: true
                                                    },
                                                ]} label="Quỹ lương tháng giữa trong quý" name="tongLuongThangGiuaStr">
                                                    <Input prefix="₫ "
                                                        disabled={idLuongQuyetToan > 0 ? true : false}
                                                        onChange={handleChangeCurrency('tongLuongThangGiua', 'tongLuongThangGiuaStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="tongLuongThangGiua" >
                                                    <Input disabled={idLuongQuyetToan > 0 ? true : false} />
                                                </Form.Item>
                                            </Col>
                                            <Col span="6">
                                                <Form.Item rules={[
                                                    {
                                                        required: true
                                                    },
                                                ]} label="Quỹ lương tháng cuối trong quý" name="tongLuongThangCuoiStr">
                                                    <Input prefix="₫ "
                                                        disabled={idLuongQuyetToan > 0 ? true : false}
                                                        onChange={handleChangeCurrency('tongLuongThangCuoi', 'tongLuongThangCuoiStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="tongLuongThangCuoi" >
                                                    <Input disabled={idLuongQuyetToan > 0 ? true : false} />
                                                </Form.Item>
                                            </Col>
                                        </>}
                                        <Col span="6">
                                            <Form.Item label="Tháng chi trả" name="thangNhan">
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    picker="month"
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn tháng"
                                                    format={["MM/YYYY", "MMYYYY"]}
                                                    onChange={(date: any) => {
                                                        if (date != null) {
                                                            setThangNhanLuong(date?.startOf('month').$d);
                                                        } else {
                                                            setThangNhanLuong(null);
                                                        }
                                                    }}
                                                    allowClear={true}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {
                                            idLuongQuyetToan > 0 &&
                                            <Col span="6">
                                                <Form.Item label="Trạng thái">
                                                    {
                                                        trangThai == 0 &&
                                                        <Tag color="processing">Khởi tạo</Tag>
                                                    }
                                                    {
                                                        trangThai == 1 &&
                                                        <Tag color="success">Đã duyệt</Tag>
                                                    }
                                                    {
                                                        trangThai == 2 &&
                                                        <Tag color="warning">Trình duyệt</Tag>
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Space>
                                            {(idLuongQuyetToan <= 0 || trangThai == 0) &&
                                                <Button
                                                    onClick={taiDuLieu}
                                                    type="primary"
                                                    loading={isLoading}
                                                    icon={<ReloadOutlined rev="" />}>
                                                    Tải dữ liệu tính lương bổ sung
                                                </Button>}
                                            {/*<Button
                                                onClick={() => setShowModal(true)}
                                                type="primary"
                                                loading={isLoading}
                                                icon={<UploadOutlined rev="" />}>
                                                Import file lương bổ sung
                                            </Button>
                                            <Button
                                                className="hrm-btn-success"
                                                htmlType="submit"
                                                loading={isLoading}
                                                icon=<DownloadOutlined rev="" />
                                            >
                                                Tải file mẫu
                                            </Button>*/}
                                            {
                                                idLuongQuyetToan > 0 && chiTietLBS?.coTheDieuChinh && trangThai == 0 && <Button
                                                    onClick={() => { setShowModalDieuChinh(true); setIsDieuChinh(true) }}
                                                    className="hrm-btn hrm-btn-warning"
                                                    icon={<SyncOutlined rev="" />}
                                                    loading={isLoading}>
                                                    Điều chỉnh
                                                </Button>
                                            }
                                        </Space>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                }]} />
        {(trangThai || 0) <= 0 &&
            <Row>
                <Col span="24">
                    <Space className="float-right">
                        <Button type="default" onClick={() => setIsEdit(!isEdit)} icon={<EditOutlined rev="" />}>{isEdit ? "Khóa" : "Chỉnh sửa"}</Button>
                    </Space>
                </Col>
            </Row>
        }
        <div className="card card-primary mt-2">
            <Table
                sticky
                scroll={{ x: 1500 }}
                loading={isLoading}
                dataSource={dataLuongBoSung.map((x: any, idx: any) => { return { ...x, key: idx } })}
                locale={{ emptyText: "Không có dữ liệu" }}
                pagination={false}
                bordered={true}
                summary={pageData => {
                    let totalLuongCBThangDau = 0;
                    let totalLuongCBThangGiua = 0;
                    let totalLuongCBThangCuoi = 0;
                    let totalLuongTTDuocNhanThangDau = 0;
                    let totalLuongTTDuocNhanThangGiua = 0;
                    let totalLuongTTDuocNhanThangCuoi = 0;
                    let totalTongCong = 0;
                    let totaltongLuongDuocNhan = 0;
                    let totaltongLuongDaNhan = 0;
                    let totalSoTienConDuocNhan = 0;
                    let totalLuongQuyMot = 0;
                    let totalLuongQuyHai = 0;
                    let totalLuongQuyBa = 0;
                    let totalLuongQuyBon = 0;
                    pageData.forEach(({ luongCBThangDau, luongCBThangGiua, luongCBThangCuoi, luongTTDuocNhanThangDau, luongTTDuocNhanThangGiua, luongTTDuocNhanThangCuoi, tongCong, tongLuongDuocNhan, tongLuongDaNhan, soTienConDuocNhan, luongQuyMot, luongQuyHai, luongQuyBa, luongQuyBon }) => {
                        totalLuongCBThangDau += luongCBThangDau;
                        totalLuongCBThangGiua += luongCBThangGiua;
                        totalLuongCBThangCuoi += luongCBThangCuoi;
                        totalLuongTTDuocNhanThangDau += luongTTDuocNhanThangDau;
                        totalLuongTTDuocNhanThangGiua += luongTTDuocNhanThangGiua;
                        totalLuongTTDuocNhanThangCuoi += luongTTDuocNhanThangCuoi;
                        totalTongCong += tongCong;
                        totaltongLuongDuocNhan += tongLuongDuocNhan;
                        totaltongLuongDaNhan += tongLuongDaNhan;
                        totalSoTienConDuocNhan += soTienConDuocNhan;
                        totalLuongQuyMot += luongQuyMot;
                        totalLuongQuyHai += luongQuyHai;
                        totalLuongQuyBa += luongQuyBa;
                        totalLuongQuyBon += luongQuyBon;
                    });
                    var thang = 0;
                    if ((pageData || []).length > 0) {
                        thang = (pageData || []).length;
                    }
                    return (
                        <>
                            <Table.Summary.Row>
                                {
                                    pageData.length > 0 && loaiQuyetToan == 1 ? loaiMuc == 0 ? <>
                                        <Table.Summary.Cell index={1} colSpan={2} align="center"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2} align="right"> <label>{formatVND(totalLuongCBThangDau)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} align="right"> <label>{formatVND(totalLuongCBThangGiua)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={4} align="right"> <label>{formatVND(totalLuongCBThangCuoi)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={5} align="right"> <label>{formatVND(totalTongCong)} </label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={6} align="right"> <label>{formatVND(totaltongLuongDuocNhan)} </label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7} align="right"> <label>{formatVND(totalSoTienConDuocNhan)} </label> </Table.Summary.Cell>
                                    </> :
                                        <>
                                            <Table.Summary.Cell index={1} colSpan={2} align="center"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} align="right"> <label>{formatVND(totalLuongCBThangDau)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={3} align="right"> <label>{formatVND(totalLuongTTDuocNhanThangDau)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={4} align="right"> <label>{formatVND(totalLuongCBThangGiua)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={5} align="right"> <label>{formatVND(totalLuongTTDuocNhanThangGiua)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={6} align="right"> <label>{formatVND(totalLuongCBThangCuoi)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={7} align="right"> <label>{formatVND(totalLuongTTDuocNhanThangCuoi)}</label></Table.Summary.Cell>
                                            <Table.Summary.Cell index={8} align="right"> <label>{formatVND(totalTongCong)} </label> </Table.Summary.Cell>
                                            <Table.Summary.Cell index={9} align="right"> <label>{formatVND(totaltongLuongDuocNhan)} </label> </Table.Summary.Cell>
                                            <Table.Summary.Cell index={10} align="right"> <label>{formatVND(totaltongLuongDaNhan)} </label> </Table.Summary.Cell>
                                            <Table.Summary.Cell index={11} align="right"> <label>{formatVND(totalSoTienConDuocNhan)} </label> </Table.Summary.Cell>
                                        </>
                                        : null}
                                {
                                    pageData.length > 0 && loaiQuyetToan == 0 &&
                                    <>
                                        <Table.Summary.Cell index={1} colSpan={2} align="center"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2} align="right"> <label>{formatVND(totalLuongQuyMot)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={3} align="right"> <label>{formatVND(totalLuongQuyHai)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={4} align="right"> <label>{formatVND(totalLuongQuyBa)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={5} align="right"> <label>{formatVND(totalLuongQuyBon)}</label></Table.Summary.Cell>
                                        <Table.Summary.Cell index={6} align="right"> <label>{formatVND(totalTongCong)} </label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7} align="right"> <label>{formatVND(totaltongLuongDuocNhan)} </label> </Table.Summary.Cell>
                                        <Table.Summary.Cell index={8} align="right"> <label>{formatVND(totalSoTienConDuocNhan)} </label> </Table.Summary.Cell>
                                    </>
                                }
                            </Table.Summary.Row>
                        </>
                    );
                }}
            >
                <Column title="Họ và tên" key="hoTen" render={(value, record, index) =>
                (
                    <>
                        {value?.hoTen}
                    </>
                )
                } />
                <Column title="Chức vụ" key="tenChucVu" render={(value, record, index) =>
                (
                    <>
                        {value?.tenChucVu}
                    </>
                )
                } />
                {loaiQuyetToan == 1 ? loaiMuc == 0 ?
                    <ColumnGroup title={"Lương và phụ cấp thực nhận quý" + " " + (quy > -1 ? quy + "/" + nam : "")}>
                        <Column title={"Tháng" + " " + (quy > -1 ? quy * 3 - 2 : "")} className="custom-column" key="luongCBThangDau" render={(value, record, index) =>
                        (
                            <>
                                {formatVND(value?.luongCBThangDau)}
                            </>
                        )
                        } />
                        <Column title={"Tháng" + " " + (quy > -1 ? quy * 3 - 1 : "")} className="custom-column" key="luongCBThangGiua" render={(value, record, index) =>
                        (
                            <>
                                {formatVND(value?.luongCBThangGiua)}
                            </>
                        )
                        } />
                        <Column title={"Tháng" + " " + (quy > -1 ? quy * 3 : "")} className="custom-column" key="luongCBThangCuoi" render={(value, record, index) =>
                        (
                            <>
                                {formatVND(value?.luongCBThangCuoi)}
                            </>
                        )
                        } />
                    </ColumnGroup>
                    :
                    <ColumnGroup title={"Lương và phụ cấp thực nhận quý" + " " + (quy > -1 ? quy + "/" + nam : "")}>
                        <ColumnGroup title={"Tháng" + " " + (quy > -1 ? quy * 3 - 2 : "")}>
                            <Column title={"LCB"} className="custom-column" key="luongCBThangDau" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongCBThangDau)}
                                </>
                            )
                            } />
                            <Column title={"LTT"} className="custom-column" key="luongTTDuocNhanThangDau" render={(value, record, index) => {
                                if (isEdit) {
                                    if (loaiQuyetToan == 1 && loaiMuc == 1) {
                                        return <Input value={formatVND(value?.luongTTDuocNhanThangDau)} onChange={(e) => {
                                            var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                            var chenhLech = v - value.luongTTDuocNhanThangDau;
                                            dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech;
                                            dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].soTienConDuocNhan + chenhLech;
                                            dataLuongBoSung[index].tongCong = dataLuongBoSung[index].tongCong + chenhLech;
                                            dataLuongBoSung[index].luongTTDuocNhanThangDau = v;
                                            setDataLuongBoSung([...dataLuongBoSung]);
                                        }} />
                                    }
                                }
                                return formatVND(value?.luongTTDuocNhanThangDau);
                            }
                            } />
                        </ColumnGroup>
                        <ColumnGroup title={"Tháng" + " " + (quy > -1 ? quy * 3 - 1 : "")}>
                            <Column title={"LCB"} className="custom-column" key="luongCBThangGiua" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongCBThangGiua)}
                                </>
                            )
                            } />
                            <Column title={"LTT"} className="custom-column" key="luongTTDuocNhanThangGiua" render={(value, record, index) => {
                                if (isEdit) {
                                    if (loaiQuyetToan == 1 && loaiMuc == 1) {
                                        return <Input value={formatVND(value?.luongTTDuocNhanThangGiua)} onChange={(e) => {
                                            var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                            var chenhLech = v - value.luongTTDuocNhanThangGiua;
                                            dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech;
                                            dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].soTienConDuocNhan + chenhLech;
                                            dataLuongBoSung[index].tongCong = dataLuongBoSung[index].tongCong + chenhLech;
                                            dataLuongBoSung[index].luongTTDuocNhanThangGiua = v;
                                            setDataLuongBoSung([...dataLuongBoSung]);
                                        }} />
                                    }
                                }
                                return formatVND(value?.luongTTDuocNhanThangGiua);
                            }
                            } />
                        </ColumnGroup>
                        <ColumnGroup title={"Tháng" + " " + (quy > -1 ? quy * 3 : "")}>
                            <Column title={"LCB"} className="custom-column" key="luongCBThangCuoi" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongCBThangCuoi)}
                                </>
                            )
                            } />
                            <Column title={"LTT"} className="custom-column" key="luongTTDuocNhanThangCuoi" render={(value, record, index) => {
                                if (isEdit) {
                                    if (loaiQuyetToan == 1 && loaiMuc == 1) {
                                        return <Input value={formatVND(value?.luongTTDuocNhanThangCuoi)} onChange={(e) => {
                                            var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                            var chenhLech = v - value.luongTTDuocNhanThangCuoi;
                                            dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech;
                                            dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].soTienConDuocNhan + chenhLech;
                                            dataLuongBoSung[index].tongCong = dataLuongBoSung[index].tongCong + chenhLech;
                                            dataLuongBoSung[index].luongTTDuocNhanThangCuoi = v;
                                            setDataLuongBoSung([...dataLuongBoSung]);
                                        }} />
                                    }
                                }
                                return formatVND(value?.luongTTDuocNhanThangCuoi);
                            }
                            } />
                        </ColumnGroup>
                    </ColumnGroup> : null
                }
                {
                    loaiQuyetToan == 0 ?
                        <ColumnGroup title={"Tiền lương năm" + " " + (nam > -1 ? nam : "")}>

                            <Column title={"Quý 1"} className="custom-column" key="luongQuyMot" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongQuyMot)}
                                </>
                            )
                            } />
                            <Column title={"Quý 2"} className="custom-column" key="luongQuyHai" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongQuyHai)}
                                </>
                            )
                            } />
                            <Column title={"Quý 3"} className="custom-column" key="luongQuyBa" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongQuyBa)}
                                </>
                            )
                            } />
                            <Column title={"Quý 4"} className="custom-column" key="luongQuyBon" render={(value, record, index) =>
                            (
                                <>
                                    {formatVND(value?.luongQuyBon)}
                                </>
                            )
                            } />
                        </ColumnGroup> : null
                }
                <Column title="Tổng cộng" className="custom-column" key="tongCong" render={(value, record, index) =>
                (
                    <>
                        {formatVND(value?.tongCong)}
                    </>
                )
                } />
                <Column title="Tổng lương được nhận" className="custom-column" key="tongLuongDuocNhan" render={(value, record, index) =>
                (
                    <>
                        {formatVND(value?.tongLuongDuocNhan)}
                    </>
                )
                } />
                {loaiMuc == 1 && <Column title="Tổng lương đã nhận" className="custom-column" key="tongLuongDaNhan" render={(value, record, index) =>
                (
                    <>
                        {formatVND(value?.tongLuongDaNhan)}
                    </>
                )
                } />}
                <Column title="Lương tăng thêm được nhận" className="custom-column" key="soTienConDuocNhan" render={(value, record, index) => {
                    if (isEdit) {
                        if (loaiQuyetToan == 1 && loaiMuc == 0) {
                            return <Input value={formatVND(value?.soTienConDuocNhan)} onChange={(e) => {
                                var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                var chenhLech = v - value.soTienConDuocNhan;
                                dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech;
                                dataLuongBoSung[index].soTienConDuocNhan = v;
                                setDataLuongBoSung([...dataLuongBoSung]);
                            }} />
                        }
                        else {
                            if (loaiQuyetToan == 0) {
                                return <Input value={formatVND(value?.soTienConDuocNhan)} onChange={(e) => {
                                    var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                    var chenhLech = v - value.soTienConDuocNhan;
                                    dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech;
                                    dataLuongBoSung[index].soTienConDuocNhan = v;
                                    setDataLuongBoSung([...dataLuongBoSung]);
                                }} />
                            }
                        }
                    }
                    return formatVND(value?.soTienConDuocNhan);
                }
                } />
            </Table>
        </div>
    </section >
}

export default LuongBoSungNLD;